import axios from 'axios'
import endpoints from '../configuration/endpoints'
import formatImages from '../utils/formatImages'

export const REQUEST_DESTINATION_DETAILS = 'REQUEST_DESTINATION_DETAILS'
export const RECEIVE_DESTINATION_DETAILS = 'RECEIVE_DESTINATION_DETAILS'
export const DESTINATION_DETAILS_ERROR = 'DESTINATION_DETAILS_ERROR'

export const requestDestinationDetails = () => dispatch => {
  dispatch({
    type: REQUEST_DESTINATION_DETAILS
  })

  return axios
    .get(endpoints.destinations)
    .then(res => {
      const destinations =
        res.data && res.data.length
          ? res.data.map(destination => {
              return {
                ...destination,
                image: formatImages(destination.image, [
                  'details-hero',
                  'user-agreement'
                ]),
                image_r: formatImages(destination['image_r'], [
                  'details-hero',
                  'user-agreement'
                ]),
                image_c: formatImages(destination['image_c'], [
                  'details-hero',
                  'user-agreement'
                ]),
                image_z: formatImages(destination['image_z'], [
                  'details-hero',
                  'user-agreement'
                ]),
                relatedSailing_image: formatImages(destination.image, [
                  'user-agreement'
                ])
              }
            })
          : []

      dispatch({
        type: RECEIVE_DESTINATION_DETAILS,
        payload: destinations
      })
    })
    .catch(err => {
      console.log(err)
      dispatch({
        type: DESTINATION_DETAILS_ERROR
      })
    })
}
